export default __webpack_public_path__ + "static/media/03_ShaYang.579e596b.png";